import { IconButton, Menu, MenuItem, styled } from '@mui/material';

export const ButtonWrapper = styled('div')(({ theme }) => ({
  backgroundColor: '#f6f8fd',
  borderRadius: '8px',
  padding: theme.spacing(1),
  display: 'flex',
  width: '40px',
  height: '40px',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const BlueIconButton = styled(IconButton)(() => ({
  color: '#0050FF',
  padding: 4,
}));

export const StyledMenu = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 4,
    marginTop: theme.spacing(1),
    minWidth: 160,
  },
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));
